import Bugsnag from '@bugsnag/js';
import ReactPlugin from '@bugsnag/plugin-react';
import { isBugsnagActive } from '@elevator/ui';

let bugsnagClient: any = null;

const init =
  isBugsnagActive() &&
  (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test');

if (init) {
  bugsnagClient = Bugsnag.start({
    apiKey: process.env.BUGSNAG_API_KEY,
    appVersion: require('../../../package.json').version,
    enabledReleaseStages: ['test', 'production'],
    releaseStage: process.env.NODE_ENV,
    onError: (report) => {
      // https://stackoverflow.com/a/64602711
      if (
        report.errors[0]?.errorMessage?.includes('Illegal invocation') &&
        report.request?.url?.includes('fbclid')
      ) {
        report.unhandled = false;
      }
    },
    plugins: [new ReactPlugin()],
  });
}

export default bugsnagClient;
